module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    class: [_vm.$style.filter, !_vm.isMsBrowser && _vm.info.filter && _vm.$style[_vm.info.filter]]
  }, [_c('img', {
    ref: "thumbnail",
    class: _vm.$style.thumbnail
  })]), _vm._v(" "), _c('div', {
    class: [_vm.$style.playButtonArea, _vm.isPC && _vm.info.iconhover ? _vm.$style.iconhover : ''],
    on: {
      "click": _vm.onPlay,
      "mousemove": _vm.onMousemove
    }
  }, [_c('PlayButton', {
    attrs: {
      "color": _vm.info.iconcolor
    }
  })], 1), _vm._v(" "), _c('TitleBar', {
    attrs: {
      "value": _vm.info.showingTitle && _vm.info.title
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33ca387c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PosterFrame.vue
// module id = 168
// module chunks = 0 1